import { render, staticRenderFns } from "./Specification.vue?vue&type=template&id=3a71921a&scoped=true"
import script from "./Specification.vue?vue&type=script&lang=js"
export * from "./Specification.vue?vue&type=script&lang=js"
import style0 from "./Specification.vue?vue&type=style&index=0&id=3a71921a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a71921a",
  null
  
)

export default component.exports